import { FilterManager } from "@search";
import { CustomerContractFilter } from "@graphql";

export class CustomerContractsFilterManager extends FilterManager<CustomerContractFilter> {}
